export const breakpoints = {
  bd1: "375px", // Bandada (mobile)
  sm: "576px",
  bd2: "750px", // Bandada (tablet)
  md: "768px",
  lg: "992px",
  xl: "1200px",
  "2xl": "1536px",
  "3xl": "1700px",
  bd3: "1920px", // Bandada (desktop)
}